import React, { Fragment, memo, useEffect, useState } from 'react'

import { ClockDateAndDay } from '../ClockDateAndDay'
import styles from './LargeWidgetTimezones.module.scss'

type LargeWidgetTimezonesProps = {
  primaryTimezone: string
  secondaryTimezones: string[]
  tzName: (tz: string) => string
  formatTimeInZone: (date: Date, timeZone: string) => string
  LiveClock: React.ComponentType<{
    timeZone: string
    size: number
    renderNumbers?: boolean
  }>
}

const LiveTimeList = memo(
  ({
    timeZones,
    tzName,
    formatTimeInZone
  }: {
    timeZones: string[]
    tzName: (tz: string) => string
    formatTimeInZone: (date: Date, timeZone: string) => string
  }) => {
    const [now, setNow] = useState<Date>(new Date())
    useEffect(() => {
      const id = setInterval(() => setNow(new Date()), 1000)
      return () => clearInterval(id)
    }, [])

    return (
      <div className={styles.tzList}>
        {timeZones.map((tz, i) => {
          return (
            <Fragment key={tz}>
              <div className={styles.tzListItem}>
                <span className={styles.tzName}>{tzName(tz)}</span>
                <span className={styles.tzTime}>
                  {formatTimeInZone(now, tz)}
                </span>
              </div>
              {i < timeZones.length - 1 && <hr />}
            </Fragment>
          )
        })}
      </div>
    )
  }
)

export const LargeWidgetTimezones: React.FC<LargeWidgetTimezonesProps> = ({
  primaryTimezone,
  secondaryTimezones,
  tzName,
  formatTimeInZone,
  LiveClock
}) => {
  return (
    <div className={styles.largeLayout}>
      {secondaryTimezones.length === 0 && <ClockDateAndDay />}
      <div className={styles.primaryClock}>
        <LiveClock timeZone={primaryTimezone} size={150} renderNumbers />
        <span className={styles.primaryTzName}>{tzName(primaryTimezone)}</span>
      </div>
      {secondaryTimezones.length > 0 && (
        <LiveTimeList
          timeZones={secondaryTimezones}
          tzName={tzName}
          formatTimeInZone={formatTimeInZone}
        />
      )}
    </div>
  )
}
